import { Injectable } from "@angular/core";
import { map, Observable, of } from "rxjs";

import { ToastType } from "../constants/toast-type";

import { ApiService } from "./api.service";
import { ToastService } from "./toast.service";
import { SessionService } from "./storage/session.service";

import { AgentMemberLogin } from "src/app/models/agent";
import { ConfirmMember, MemberSearchPayload, MemberSearchResult, MemberSearchResultResponse } from "../models/member-lookup";
import { Member, UpdateMemberProfile } from "../models/member";
import { UpdateEmailCriteria } from "../models/auth";
import { Alert } from "../models/alert";


const controllerRoute = '/members';
const controllerProfileRoute = '/myprofile';

@Injectable()
export class MemberService {

    constructor(
        private apiService: ApiService,
        private sessionService: SessionService,
        private toastService: ToastService,
    ) {
    }

    public searchMembers(payload: MemberSearchPayload): Observable<MemberSearchResult[]> {
        return this.apiService.post(`${controllerRoute}/specification`, payload).pipe(
            map((response: MemberSearchResultResponse) => {
                if (!response.matchingMembers || response.matchingMembers.length == 0) {
                    if (payload.isTestQ)
                        this.toastService.buildToastMessage(ToastType.warning, "", "No Test Members Found!");
                    else
                        this.toastService.buildToastMessage(ToastType.warning, "", "No Members Found!");
                }
                return response.matchingMembers;
            }),
        );
    }

    public getTestMembers(payload: MemberSearchPayload): Observable<MemberSearchResult[]> {
        return this.apiService.post(`${controllerRoute}/test-members`, payload).pipe(
            map((response: MemberSearchResultResponse) => {
                if (!response.matchingMembers || response.matchingMembers.length == 0)
                    this.toastService.buildToastMessage(ToastType.warning, "", "No Test Members Found!");
                return response.matchingMembers;
            }),
        );
    }

    public getMemberConfirmation(selectedMember: MemberSearchResult): Observable<ConfirmMember> {
        return this.apiService.get(`${controllerRoute}/confirmation/${selectedMember.systemNumber}`).pipe(
            map((response: ConfirmMember) => {
                this.sessionService.versionSetGuard(response.version);
                return response;
            }),
        );
    }

    // Odd logic to save member informaiton first before setting the member when an agent
    public setAgentMemberConfirmation(payload: AgentMemberLogin): Observable<void> {
        return this.apiService.post(`${controllerRoute}/confirmation`, payload).pipe(
            map((response: ConfirmMember) => {
            }),
        );
    }

    public getMemberProfile(): Observable<Member> {
        return this.apiService.get(`${controllerProfileRoute}`).pipe(
            map((response: Member) => {
                return response;
            }),
        );
    }

    public saveMemberProfile(payload: UpdateMemberProfile): Observable<null> {
        return this.apiService.post(`${controllerProfileRoute}/save-demographics`, payload).pipe(
            map(() => {
                this.toastService.buildToastMessage(ToastType.success, 'Member Saved', 'Member profile changes saved!');
                return null;
            }),
        );
    }

    public saveRegistredEmail(payload: UpdateEmailCriteria): Observable<null> {
        return this.apiService.post(`${controllerProfileRoute}/update-email`, payload).pipe(
            map(() => {
                this.toastService.buildToastMessage(ToastType.success, '', 'Registered email updated!');
                return null;
            }),
        );
    }

    public getMessageCenter(): Observable<Alert[]> {
        if (this.sessionService.session?.member?.messageCenterAlerts)
            of (this.sessionService.session.member.messageCenterAlerts);

        return this.apiService.post(`${controllerRoute}/message-center`, null).pipe(
            map((response: Alert[]) => {
                this.sessionService.session.member.messageCenterAlerts = response;
                this.sessionService.setSession();
                return response;
            }),
        );
    }

    public resetMessageCenter(): void {
        this.sessionService.session.member.messageCenterAlerts = null;
        this.sessionService.setSession();
    }
}